import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import markdownToSafeHtml from '../../common/markdownToSafeHtml';

import FormEditorTopbar from './formEditorTopbar';
import FormViewer from '../../FormViewer';
import FormEditorRightPanel from './formEditorRightPanel';
import shapes from '../../common/shapes';
import { FORM_EDITOR_MODE } from '../../common/globals';
import Tpl from '../../FormViewer/FieldTemplate';
import FormLoader from '../../FormClient/components/FormLoader';

import './formEditor.css';

class FormEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newElementType: ''
    };
  }

  componentDidMount() {
    const {
      formId,
      onFormEditorInitialize,
      token
    } = this.props;

    onFormEditorInitialize(formId, token);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isDeleted && this.props.isDeleted) {
      this.handleBackButtonClick();
    }
  }

  handleClickFormElement = (newSelectedElement) => {
    const {
      selectedElement,
      mode,
      onFormEditorModeChange,
      onFormElementSelected
    } = this.props;

    const selectedElementIsNull = _.isNull(selectedElement);
    const newSelectedElementIsNotObject = newSelectedElement.type !== 'object';

    if (newSelectedElementIsNotObject) {
      if (selectedElementIsNull) {
        onFormElementSelected(newSelectedElement);
      }
      else if (selectedElement.id !== newSelectedElement.id) {
        onFormElementSelected(newSelectedElement);
      }
    }

    if (mode !== FORM_EDITOR_MODE.EDIT_FIELD) {
      onFormEditorModeChange(FORM_EDITOR_MODE.EDIT_FIELD);
    }
  };

  handleFormElementChange = (target) => {
    const { onFormElementChange } = this.props;

    onFormElementChange(target);
  };

  handleFormElementCloseEditor = () => {
    const {
      onFormEditorModeChange
    } = this.props;

    onFormEditorModeChange(FORM_EDITOR_MODE.EDIT_FORM);
  };

  handleBackButtonClick = () => {
    if (window.parent === window) {
      return;
    }

    let parentOrigin = window.location.ancestorOrigins && window.location.ancestorOrigins[0];
    if (!parentOrigin && /^https?:\/\//.test(document.referrer)) {
      parentOrigin = new URL(document.referrer).origin;
    }
    if (!parentOrigin) {
      return;
    }

    window.parent.postMessage({ type: 'appActionDone' }, parentOrigin);
  };

  handleViewForm = () => {
    const {
      form
    } = this.props;

    window.open(form.link, '_newtab');
  };

  handleQuestionTypeSelect = (ev) => {
    const {
      value: newElementType
    } = ev.target;

    this.setState({
      newElementType
    });
  };

  handleAddElement = () => {
    const {
      newElementType
    } = this.state;

    if (_.isEmpty(newElementType)) {
      return;
    }

    const {
      onFormEditorAddElement,
      onFormEditorModeChange
    } = this.props;

    onFormEditorAddElement(newElementType);
    onFormEditorModeChange(FORM_EDITOR_MODE.EDIT_FIELD);
  };

  handleSave = (republish) => {
    const {
      onFormSave,
      token
    } = this.props;

    onFormSave(republish, token);
  };

  handleFormDelete = () => {
    const {
      onFormDelete,
      token
    } = this.props;

    onFormDelete(token);
  };

  handleFormPublish = () => {
    const {
      onFormPublish,
      token
    } = this.props;

    onFormPublish(token);
  };

  render() {
    const {
      isInitializing,
      isSaving,
      isPublishing,
      isDeleting,
      isModified,
      teamName,
      mode,
      selectedElement,
      form,
      onFormElementTypeChange,
      onMoveUp,
      onMoveDown,
      onFormElementRemove,
      onFormPreviewChange,
      onFormElementRequiredChange,
      onFormElementOptionsChange,
      onPrivacyChange
    } = this.props;

    const {
      status,
      JSONSchema,
      UISchema,
      formData,
      headerImage,
      buttonColor,
      buttonLabel,
      confirmationText
    } = form;

    const formContext = {
      onClickElement: this.handleClickFormElement,
    };

    formContext.selectedElementId = _.isNull(selectedElement)
      ? ''
      : selectedElement.id;

    if (headerImage) {
      formContext.headerImage = headerImage;
    }
    if (buttonColor) {
      formContext.buttonColor = buttonColor;
    }
    if (!_.isUndefined(buttonLabel)) {
      formContext.buttonLabel = buttonLabel;
    }

    const {
      newElementType
    } = this.state;

    const RightPanelSkeleton = () => (
      <div
        style={{
          padding: 20
        }}
      >
        <div
          className="pulse"
          style={{
            height: 18,
            width: '50%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 16
          }}
        />
        <div
          className="pulse"
          style={{
            height: 12,
            width: '80%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 12
          }}
        />
        <div
          className="pulse"
          style={{
            height: 12,
            width: '60%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 20
          }}
        />
        <div
          className="pulse"
          style={{
            height: 36,
            width: '100%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 16
          }}
        />
        <div
          className="pulse"
          style={{
            height: 12,
            width: '70%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 12
          }}
        />
        <div
          className="pulse"
          style={{
            height: 36,
            width: '100%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 16
          }}
        />
        <div
          className="pulse"
          style={{
            height: 12,
            width: '85%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 12
          }}
        />
        <div
          className="pulse"
          style={{
            height: 36,
            width: '100%',
            backgroundColor: '#eceff3',
            borderRadius: 6,
            marginBottom: 16
          }}
        />
      </div>
    );

    const content = isInitializing
      ? (
        <div className="form-editor-container">
          <div className="form-editor-container-viewer">
            <FormLoader />
          </div>
          <div className="form-editor-container-properties">
            <RightPanelSkeleton />
          </div>
        </div>
      )
      : (
        <Fragment>
          <FormEditorTopbar
            status={status}
            privacy={form.privacy}
            isSaving={isSaving}
            isPublishing={isPublishing}
            isDeleting={isDeleting}
            isModified={isModified}
            onSave={this.handleSave}
            onDelete={this.handleFormDelete}
            onPublish={this.handleFormPublish}
            onView={this.handleViewForm}
            onBackButtonClick={this.handleBackButtonClick}
            onPrivacyChange={onPrivacyChange}
            teamName={teamName}
          />
          <div className="form-editor-container">
            <div className="form-editor-container-viewer">
              <div className="help">
                <span className="label label-default">FORM PREVIEW</span>
              </div>
              <FormViewer
                schema={JSONSchema}
                uiSchema={UISchema}
                formData={formData}
                formContext={formContext}
                canSubmit={false}
                fieldTemplate={Tpl}
                onChange={onFormPreviewChange}
              />
              <div className="new-question row">
                <div className="col-md-6">
                  <select
                    className="form-control"
                    id="new-question-type"
                    name="newElementType"
                    value={newElementType}
                    onChange={this.handleQuestionTypeSelect}
                  >
                    <option> Select a question type </option>
                    <option value="shortText"> Short text </option>
                    <option value="paragraph"> Paragraph </option>
                    <option value="number"> Number </option>
                    <option value="date"> Date </option>
                    <option value="multipleChoice"> Multiple choice </option>
                    <option value="attachment"> Attachment </option>
                  </select>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-success form-control"
                    onClick={this.handleAddElement}
                  >
                    Add question
                  </button>
                </div>
              </div>
              {/* Live success preview */}
              <div style={{ marginTop: 32 }}>
                <div className="help">
                  <span className="label label-default">SUCCESS PREVIEW</span>
                </div>
                {(() => {
                  const lighten = (hex, factor = 0.9) => {
                    const normalized = hex ? hex.replace('#', '') : '5986ff';
                    const full = normalized.length === 3
                      ? normalized.split('').map(c => c + c).join('')
                      : normalized;
                    const r = parseInt(full.substring(0, 2), 16);
                    const g = parseInt(full.substring(2, 4), 16);
                    const b = parseInt(full.substring(4, 6), 16);
                    const mix = c => Math.round(c + (255 - c) * factor);
                    const toHex = n => n.toString(16).padStart(2, '0');
                    return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`;
                  };
                  const heroStyle = headerImage
                    ? {}
                    : { backgroundColor: lighten(buttonColor, 0.92) };
                  const cloudinaryBase = 'https://res.cloudinary.com/dqlpbfemc/image/fetch/t_form_banner';
                  const transformedHeaderImage = headerImage
                    ? `${cloudinaryBase}/${encodeURI(headerImage)}`
                    : '';
                  const tickCircleStyle = {
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: 'transparent',
                    border: '2px solid #000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  };
                  return (
                    <div className="form-viewer">
                      <div className="form-hero" style={heroStyle}>
                        {headerImage && (
                          <div className="form-hero__image">
                            <img alt="hero" src={transformedHeaderImage} />
                          </div>
                        )}
                        <div className="form-hero__content">
                          <div style={{ display: 'flex', justifyContent: 'left', margin: '16px 0' }}>
                            <div style={tickCircleStyle}>
                              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M7 12.5L11 16.5L17.5 9" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </div>
                          </div>
                          {confirmationText && _.trim(confirmationText) !== '' ? (
                            <div
                              className="form-hero__description"
                              style={{ marginTop: 8 }}
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={
                                { __html: markdownToSafeHtml(confirmationText) }
                              }
                            />
                          ) : (
                            <h1 className="form-hero__title">Your submission has been received</h1>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
            <div className="form-editor-container-properties">
              <FormEditorRightPanel
                mode={mode}
                teamName={teamName}
                selectedElement={selectedElement}
                onAddElement={this.handleAddElement}
                onFormElementChange={this.handleFormElementChange}
                onFormElementTypeChange={onFormElementTypeChange}
                onFormElementRemove={onFormElementRemove}
                onMoveUp={onMoveUp}
                onMoveDown={onMoveDown}
                onFormElementCloseEditor={this.handleFormElementCloseEditor}
                onFormElementRequiredChange={onFormElementRequiredChange}
                onFormElementOptionsChange={onFormElementOptionsChange}
              />
            </div>
          </div>
        </Fragment>
      );

    return (
      <div className="form-editor-page">
        {content}
      </div>
    );
  }
}

FormEditor.defaultProps = {
  selectedElement: null,
  teamName: ''
};

FormEditor.propTypes = {
  formId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  isInitializing: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isPublishing: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  isDeleted: PropTypes.bool.isRequired,
  isModified: PropTypes.bool.isRequired,
  teamName: PropTypes.string,
  mode: PropTypes.oneOf(_.values(FORM_EDITOR_MODE)).isRequired,
  selectedElement: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string
  }),
  form: PropTypes.shape(shapes.formWithSchema).isRequired,
  onFormEditorInitialize: PropTypes.func.isRequired,
  onFormSave: PropTypes.func.isRequired,
  onFormDelete: PropTypes.func.isRequired,
  onFormPublish: PropTypes.func.isRequired,
  onFormEditorModeChange: PropTypes.func.isRequired,
  onFormElementSelected: PropTypes.func.isRequired,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementTypeChange: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  onFormElementRemove: PropTypes.func.isRequired,
  onFormPreviewChange: PropTypes.func.isRequired,
  onFormEditorAddElement: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onFormElementOptionsChange: PropTypes.func.isRequired,
  onPrivacyChange: PropTypes.func.isRequired,
};

export default FormEditor;
